export default __webpack_public_path__ + "static/media/ocean-bubbles.1db2c02e.jpg";